import React, { memo, useState } from 'react';

interface CustomDropdownProps {
  options: { value: string; label: string }[];
  selectedValue: string;
  onChange: (value: string) => void;
}

const CustomDropdown: React.FC<CustomDropdownProps> = ({ options, selectedValue, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOptionClick = (value: string) => {
    onChange(value);
    setIsOpen(false);
  };

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        fontSize: '16px',
        color: '#333',
      }}
    >
      <div
        onClick={() => setIsOpen(!isOpen)}
        style={{
          padding: '10px',
          border: '0px solid #ccc',
          borderRadius: isOpen ? '20px 20px 0 0' : '50px',
          cursor: 'pointer',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          backgroundColor: 'rgba(0, 0, 0, 0.1)',
          boxShadow: isOpen ? '0 4px 6px rgba(0, 0, 0, 0.1)' : '0 0px px rgba(0, 0, 0, 0)',
        }}
      >
        <span>{options.find((option) => option.value === selectedValue)?.label || 'Select an option'}</span>
        <span style={{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }}>▼</span>
      </div>
      {isOpen && (
        <div
          style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            width: '100%',
            border: '0px solid #ccc',
            backgroundColor: '#fff',
            zIndex: 10,
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            borderRadius: isOpen ? '0px 0px 20px 20px' : '50px',
            overflow: 'hidden',
          }}
        >
          {options.map((option) => (
            <div
              key={option.value}
              onClick={() => handleOptionClick(option.value)}
              style={{
                padding: '10px',
                cursor: 'pointer',
                backgroundColor: selectedValue === option.value ? '#2093ff' : '#fff',
                transition: 'background-color 0.2s',
                color: selectedValue === option.value ? 'white' : '#333',
              }}
              onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#f9f9f9')}
              onMouseOut={(e) => (e.currentTarget.style.backgroundColor = selectedValue === option.value ? '#f0f0f0' : '#fff')}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default memo(CustomDropdown);